import { useNavigate } from 'react-router-dom';

import { IconManager } from '@speeki/icons';

import SpeekiLogo from '@assets/images/speeki_logo.svg';

import { TenantLogoDocument } from '@graphql/generated/graphql';

import { useResponsive } from '@utils/hooks/useResponsive';
import { useUserCompany } from '@utils/hooks/useUserCompany';

import { AuthService } from '@services/AuthService/AuthService';
import { getPath } from '@services/RouteService/paths';

import { useQuery } from '@apollo/client';

import {
    BrandLogo,
    BrandLogoWrapper,
    HeaderLogoWrapper,
    SpeekiLogoWrapper,
} from './HeaderLogos.styled';

export const HeaderLogos = () => {
    const tenantUuid = AuthService.getTenantUuid();
    const isLg = useResponsive('lg');

    const navigate = useNavigate();

    const { data: userData } = useUserCompany();
    const { data: tenantData } = useQuery(TenantLogoDocument, {
        skip: !tenantUuid,
        variables: {
            uuid: tenantUuid || '',
        },
    });
    const logo = userData?.user.tenant?.logo || tenantData?.tenant.logo;

    return (
        <HeaderLogoWrapper>
            <BrandLogoWrapper onClick={() => navigate(getPath({ path: '/' }))}>
                <BrandLogo src={logo || SpeekiLogo} />
            </BrandLogoWrapper>
            {logo && !isLg && (
                <SpeekiLogoWrapper>
                    <IconManager icon="SvgPoweredBySpeeki" size={79} />
                </SpeekiLogoWrapper>
            )}
        </HeaderLogoWrapper>
    );
};
